<template>
  <div class="handout-wrapper">
    <p class="handout_title"><img @click='close' src="../../../static/images/cancel.png" alt="">{{files.handouts_name}}
    </p>
    <div class="handout_list">
      <p target="_blank" @click="preview(cid, packageid, i, files.menu_id)" class="open_file"
         v-for='i in files.pdf_info'><img class="handout_pic" src="../../../static/images/doc.png" alt="">{{i.name}}</p>
    </div>
  </div>
</template>
<script>

  export default {
    data () {
      return {}
    },
    props: ['files', 'cid', 'packageid'],
    mounted () {

    },
    methods: {
      close () {
        this.$emit('child', 'false')
      },
      preview (cid, package_id, data, unit_id) {
        this.$router.push({
          path: '/file',
          query: {
            order_id: this.$route.query.order_id,
            package_id: package_id,
            cid: cid,
            unit_id: unit_id,
            module_type: 7,
            other: {ID: data.id, name: data.name, url: data.url},
            url: data.url
          },
        })
      }
    }
  }
</script>

<style lang="less">
  .handout-wrapper {
    width: 100%;
    height: 100%;
    background: #ffffff;
    .handout_title {
      padding-left: 20px;
      height: 70px;
      line-height: 70px;
      font-size: 32px;
      background: #e6e6e6;
      position: fixed;
      left: 0;
      right: 0;
      img {
        width: 22px;
        margin-right: 20px;
      }
    }
    .handout_list {
      padding-top: 60px;
      .open_file {
        font-size: 28px;
        padding: 20px;
        display: flex;
        align-items: center;
        color: #333333;
        .handout_pic {
          width: 44px;
          height: 42px;
          margin-right: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/handout/index.vue